import React , {useState, useEffect}from "react";
import { useSelector, useDispatch } from 'react-redux';
import { updateFormField, } from './Slices/formSlice';


export default function Behaviors() {
  const dispatch = useDispatch();
  const jdResponsesArrays = useSelector((state) => state.jdResponses);
  const formData = useSelector((state) => state.form);
  // const [behaviorsDataApi, setBehaviorsDataApi] = useState({})
  //  function transformBehaviouralJD(behaviouralJD) {
  //     const { selected, non_selected, justifications } = behaviouralJD;
  //     
  //   
  //     const mapBehavior = (code, isSelected = true) => {
  //       const trait = behaviourTraits[code];
  //       const justification = justifications[code];
  //       const description = isSelected
  //         ? justification.reason
  //         : justification.reason; // Can modify if different for nonSelected
  //   
  //       return {
  //         title: trait,
  //         description,
  //         behaviourCode: code,
  //       };
  //     };
  //   
  //     const transformed = {
  //       selected: selected?.map(code => mapBehavior(code, true)),
  //       nonSelected: non_selected?.map(code => mapBehavior(code, false)),
  //     };
  //   
  //     return transformed;
  //   }
    const behaviourTraits = {
      A: "Accuracy",
      B: "Cooperativeness",
      C: "Efficiency",
      D: "Enthusiasm",
      E: "Friendliness",
      F: "Independence",
      G: "Patience",
      H: "Persistence",
      I: "Self Confidence",
      J: "Self Motivation",
      K: "Sensitivity",
      L: "Thoughtfulness"
    };
  //   function transformBehaviouralJD(behaviouralJD) {
  //     const { selected, non_selected, justifications } = behaviouralJD;
  //   
  //     const mapSelected = (code) => {
  //       const trait = behaviourTraits[code];
  //       const justification = justifications[code] || {};
  //   
  //       return {
  //         title: trait,
  //         behaviourCode: code,
  //         reasonForSelection: justification.reason,
  //         comparison: justification.compared_to,
  //         conditionForReconsideration: justification.deprioritize_conditions,
  //       };
  //     };
  //   
  //     const mapNonSelected = (code) => {
  //       const trait = behaviourTraits[code];
  //       const justification = justifications[code] || {};
  //   
  //       return {
  //         title: trait,
  //         behaviourCode: code,
  //         reasonForNonSelection: justification.reason,
  //         comparison: justification.compared_to,
  //         conditionForReconsideration: justification.deprioritize_conditions,
  //         selfConfidence: justification.self_confidence,
  //       };
  //     };
  //   
  //     return {
  //       selected: selected.map(mapSelected),
  //       nonSelected: non_selected.map(mapNonSelected),
  //     };
  //   }
  // useEffect(()=>{
  //  if(formData?.identifiedBehaviour?.behavioural_jd ){
  //       const modifedData = transformBehaviouralJD(formData?.identifiedBehaviour?.behavioural_jd)
  //       // setBehaviorsDataApi(modifedData)
  //        dispatch(updateFormField({ field : 'behaviorsDataApi', value: modifedData }))
  //  }
  // },[formData?.identifiedBehaviour])
  const behaviorsData = {
    critical: [
      {
        title: "Accuracy",
        description:
          "Accuracy is critical due to the 'no room for errors' challenge and the need for thoroughness in execution. It's vital for this middle management role.",
      },
      {
        title: "Self Confidence",
        description:
          "Self-confidence is essential for a role that requires initiative in crisis situations and sole decision-making authority. It allows the individual to act decisively.",
      },
    ],
    selected: [
      {
        title: "Accuracy",
        description:
          "Accuracy is critical due to the 'no room for errors' challenge and the need for thoroughness in execution. It's vital for this middle management role.",
      },
      {
        title: "Efficiency",
        description:
          "Efficiency is important for executing assigned tasks and adhering to unpredictable deadlines, ensuring timely completion even under pressure.",
      },
      {
        title: "Independence",
        description:
          "Independence is needed as the individual is the 'sole decision maker' and must 'think of the best way to address the crisis and take initiative immediately'.",
      },
      {
        title: "Persistence",
        description:
          "Persistence is important because the role involves executing tasks, even when faced with strict management and long/odd working hours. Overcoming challenges is key.",
      },
      {
        title: "Self Confidence",
        description:
          "Self-confidence is essential for a role that requires initiative in crisis situations and sole decision-making authority. It allows the individual to act decisively.",
      },
      {
        title: "Self Motivation",
        description:
          "Self-motivation is required for a new role in a new area, as the individual needs to be proactive and driven to succeed without much external direction.",
      },
    ],
    nonSelected: [
      {
        title: "Cooperativeness",
        description:
          "Cooperativeness is less critical as the role involves independent decision-making and infrequent communication primarily with the supervisor.",
      },
      {
        title: "Enthusiasm",
        description:
          "Enthusiasm is less critical than other behaviors because the role primarily focuses on execution and adherence to change plans.",
      },
      {
        title: "Friendliness",
        description:
          "Friendliness is not as important because the role's focus is on execution and decision-making, not interpersonal relationships.",
      },
      {
        title: "Patience",
        description:
          "Patience is less vital as the role requires initiative in crisis situations, prioritizing action over long deliberation.",
      },
      {
        title: "Sensitivity",
        description:
          "Sensitivity is not a key behavior as the role emphasizes execution over emotion or personal sensitivity.",
      },
      {
        title: "Thoughtfulness",
        description:
          "Thoughtfulness is less necessary as the emphasis is on decisive action rather than deep reflection.",
      },
    ],
  };

  // const renderSection = (title, icon, behaviors) => (
  //   <div>
  //     <h4 className=" mb-3" style={{ fontSize: "var(--font-size-h3)", fontWeight: 700 }}>
  //       {icon} {title}
  //     </h4>
  //     {console.log('behaviour-->', behaviors)}
  //     {behaviors?.map((item, index) => (
  //       <div key={index} className="mb-3">
  //         <div className="d-flex justify-content-between align-items-start mt-4">
  //           <strong style={{ fontSize: "var(--font-size-h4)" }}>{item.title}</strong>
  //           {/* <button
  //             className="btnVldt"
  //             style={{ fontSize: "var(--font-size-h4)", height: "32px" }}
  //           >
  //             Explain
  //           </button> */}
  //         </div>
  //         <div className="d-flex flex-column justify-content-between align-items-start mt-2">
  //         <div>     <strong style={{ fontSize: "var(--font-size-h4)" }}>Reason For Selection</strong> </div>
  //          <div> <p className="small mt-1">{item.reasonForSelection}</p> </div>
  //          <div>     <strong style={{ fontSize: "var(--font-size-h4)" }}>comparison</strong> </div>
  //          <div> <p className="small mt-1">{item.comparison}</p> </div>
  //          <div>     <strong style={{ fontSize: "var(--font-size-h4)" }}>condition For Reconsideration</strong> </div>
  //          <div> <p className="small mt-1">{item.conditionForReconsideration}</p> </div>
  //         </div>
  //        
  //       </div>
  //     ))}
  //   </div>
  // );

  const renderSection = (title, icon, behaviors, isSelected = true) => (
    <div>
      <h4 className="mb-3" style={{ fontSize: "var(--font-size-h3)", fontWeight: 700 }}>
        {icon} {title}
      </h4>
      {behaviors?.map((item, index) => (
        <div key={index} className="mb-3">
          <div className="d-flex justify-content-between align-items-start mt-4">
            <strong style={{ fontSize: "var(--font-size-h4)" }}>{item.title}</strong>
          </div>
  
          <div className="d-flex flex-column justify-content-between align-items-start mt-2">
            <div>
              <strong style={{ fontSize: "var(--font-size-h4)" }}>
                {isSelected ? "Reason For Selection" : "Reason For Non-Selection"}
              </strong>
            </div>
            <div>
              <p className="small mt-1">
                {isSelected ? item.reasonForSelection : item.reasonForNonSelection}
              </p>
            </div>
  
            <div>
              <strong style={{ fontSize: "var(--font-size-h4)" }}>Comparison</strong>
            </div>
            <div>
              <p className="small mt-1">{item.comparison}</p>
            </div>
  
            <div>
              <strong style={{ fontSize: "var(--font-size-h4)" }}>Condition For Reconsideration</strong>
            </div>
            <div>
              <p className="small mt-1">{item.conditionForReconsideration}</p>
            </div>
  
            {!isSelected && item.selfConfidence && (
              <>
                <div>
                  <strong style={{ fontSize: "var(--font-size-h4)" }}>Self Confidence</strong>
                </div>
                <div>
                  <p className="small mt-1">{item.selfConfidence}</p>
                </div>
              </>
            )}
          </div>
        </div>
      ))}
    </div>
  );
  
  return (
    <div>
      <div className="p-4">
        <h3 className="ja-1">Behaviors</h3>

        <div className="col-md-12 mt-4">
          <div className="row">
            {/* <div className="col-md-4">
              {renderSection(
                "Critical Behaviors",
                "🌟",
                behaviorsDataApi.critical
              )}
            </div> */}
            {/* <div className="col-md-6">
              {renderSection(
                "Selected Behaviors",
                "✅",
                formData.behaviorsDataApi.selected
              )}
            </div>
            <div className="col-md-6">
              {renderSection(
                "Non-Selected Behaviors",
                "❌",
                formData.behaviorsDataApi.nonSelected
              )}
            </div> */}

            <div className="col-md-6">
  {renderSection(
    "Selected Behaviors",
    "✅",
    formData.behaviorsDataApi.selected,
    true // isSelected
  )}
</div>
<div className="col-md-6">
  {renderSection(
    "Non-Selected Behaviors",
    "❌",
    formData.behaviorsDataApi.nonSelected,
    false // not selected
  )}
</div>

          </div>
        </div>
      </div>
   
    </div>
  );
}
